"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartSelectorsFactory = void 0;
const chart_selectors_1 = require("../../state/chart_selectors");
const get_internal_is_intialized_1 = require("../../state/selectors/get_internal_is_intialized");
exports.chartSelectorsFactory = (0, chart_selectors_1.createChartSelectorsFactory)({
    getChartTypeDescription: () => 'Timeslip chart',
    isInitialized: () => get_internal_is_intialized_1.InitStatus.Initialized,
    isChartEmpty: () => false,
    getTooltipAnchor: () => ({ x: 0, y: 0, width: 0, height: 0 }),
    getTooltipInfo: () => ({ header: null, values: [] }),
});
//# sourceMappingURL=chart_selectors.js.map